import * as React from "react";
import { WhitelabelSettings } from "kmmp";
import { ShadowBoxColor } from "kmmp/frontend";
import { PublicImage } from "client/components/public-image";

interface IProps extends React.Props<any> {
    box: ShadowBoxColor;
    whitelabelSettings: WhitelabelSettings;
    displayAsPackage: boolean;
    src: string;
}

export function ShadowBoxPreview(props: IProps): JSX.Element {
    return <PublicImage className="img-responsive" style={{ objectFit: "contain" }} src={props.src} alt={"Package preview"} />;
}
